import React from "react";
import UpdateStoreComponent from "../components/UpdateStoreComponent";
import { useLocation } from "react-router-dom";
import usePushBack from "hooks/usePushBack";

const UpdateStore = () => {
  const location = useLocation();
  const storeId =
    location?.state?.storeId ||
    new URLSearchParams(location.search || "").get("storeId");
  usePushBack("/app/dashboard/stores", storeId);
  return <UpdateStoreComponent />;
};
export default UpdateStore;
